// extracted by mini-css-extract-plugin
module.exports = {"asideSection":"asideBlogSection-module--asideSection--1vNPd","asideContent":"asideBlogSection-module--asideContent--1Ftib"};